import { Section, Tier } from './types';

/** 
 * WORKFLOW CONFIGURATION
 * We split the URLs by purpose to prevent duplicate entries in your Microsoft List.
 */
// URL 1: Dedicated to storing the Lead in your Microsoft List
export const PRIMARY_STORAGE_URL = 'https://default55c1f1fb8f1a4b1d829fa3ea1bd31e.7e.environment.api.powerplatform.com:443/powerautomate/automations/direct/workflows/1f6f5b31182e43fdbf4b42f9e1b5ad80/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=GVa9dKFaQEEMkeoo0Uc0dDA3SnNEbRR3w25vCRDMzdE';

// URL 2: Dedicated to the Email Report automation
export const AUTOMATION_EMAIL_URL = 'https://default55c1f1fb8f1a4b1d829fa3ea1bd31e.7e.environment.api.powerplatform.com:443/powerautomate/automations/direct/workflows/e8cdad6bcb874be18633dfa542e08a8f/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=ZL63EUxqhfMrJDk8h3ay_X6L49YaRy_JqsQj7aB7iG0';

export const SCHEDULING_LINK = 'https://calendly.com/lligtermoetddgeurope/fintech-scan-strategy-call';
export const PRIVACY_URL = 'https://ddg-europe.com/privacy-policy/';

/**
 * Utility to ensure Power Automate receives perfectly valid JSON.
 */
export const sanitizePayload = (obj: any): any => {
  return JSON.parse(JSON.stringify(obj, (key, value) => {
    if (value === undefined) return null;
    return value;
  }));
};

export const SECTOR_OPTIONS = [
  'Payments', 'Banking‑as‑a‑Service', 'Wealth/Investing', 'Lending', 
  'Insurance/Insurtech', 'Crypto/Web3', 'RegTech', 'Open Finance', 'BNPL', 'Other'
];

export const SECTIONS: Section[] = [
  {
    id: 'A',
    title: 'Trade Shows & Sponsorships',
    questions: [
      {
        id: 1,
        text: 'How do you currently measure the ROI of your trade show participation?',
        options: [
          { text: 'Yes, fully measured', value: 3 },
          { text: 'Partially measured', value: 2 },
          { text: 'No', value: 1 }
        ]
      },
      {
        id: 2,
        text: 'Are trade shows integrated with other events, campaigns, or content initiatives?',
        options: [
          { text: 'Fully', value: 3 },
          { text: 'Partially', value: 2 },
          { text: 'Not at all', value: 1 }
        ]
      },
      {
        id: 3,
        text: 'Do you have a follow-up strategy in place to extend impact after trade shows?',
        options: [
          { text: 'Yes', value: 3 },
          { text: 'Partial', value: 2 },
          { text: 'No', value: 1 }
        ]
      }
    ]
  },
  {
    id: 'B',
    title: 'Customer Events',
    questions: [
      {
        id: 4,
        text: 'How frequently do you organize events for existing customers?',
        options: [
          { text: 'Monthly', value: 3 },
          { text: 'Quarterly', value: 2 },
          { text: 'Rarely', value: 1 }
        ]
      },
      {
        id: 5,
        text: 'Are these events linked to commercial goals (upsell/cross-sell)?',
        options: [
          { text: 'Yes', value: 3 },
          { text: 'Partially', value: 2 },
          { text: 'No', value: 1 }
        ]
      },
      {
        id: 6,
        text: 'Do you actively measure attendee satisfaction and follow-up?',
        options: [
          { text: 'Yes', value: 3 },
          { text: 'Partially', value: 2 },
          { text: 'No', value: 1 }
        ]
      }
    ]
  },
  {
    id: 'C',
    title: 'Partner & Ecosystem Events',
    questions: [
      {
        id: 7,
        text: 'Do you co-create events with strategic partners?',
        options: [
          { text: 'Yes', value: 3 },
          { text: 'Partially', value: 2 },
          { text: 'No', value: 1 }
        ]
      },
      {
        id: 8,
        text: 'Are partner events part of an annual ecosystem roadmap?',
        options: [
          { text: 'Yes', value: 3 },
          { text: 'Partially', value: 2 },
          { text: 'No', value: 1 }
        ]
      },
      {
        id: 9,
        text: 'Do these events generate measurable business opportunities?',
        options: [
          { text: 'Yes', value: 3 },
          { text: 'Partially', value: 2 },
          { text: 'No', value: 1 }
        ]
      }
    ]
  },
  {
    id: 'D',
    title: 'Executive & VIP Events',
    questions: [
      {
        id: 10,
        text: 'Are key stakeholders personally engaged through exclusive events?',
        options: [
          { text: 'Yes', value: 3 },
          { text: 'Partial', value: 2 },
          { text: 'No', value: 1 }
        ]
      },
      {
        id: 11,
        text: 'Do you follow up with executives to maintain and deepen relationships?',
        options: [
          { text: 'Yes', value: 3 },
          { text: 'Partial', value: 2 },
          { text: 'No', value: 1 }
        ]
      },
      {
        id: 12,
        text: 'Are these events integrated with marketing and sales pipelines?',
        options: [
          { text: 'Yes', value: 3 },
          { text: 'Partial', value: 2 },
          { text: 'No', value: 1 }
        ]
      }
    ]
  },
  {
    id: 'E',
    title: 'Measurement & Activation',
    questions: [
      {
        id: 13,
        text: 'Are all events linked to measurable KPIs (pipeline, engagement, brand impact)?',
        options: [
          { text: 'Yes', value: 3 },
          { text: 'Partial', value: 2 },
          { text: 'No', value: 1 }
        ]
      },
      {
        id: 14,
        text: 'Do you have a continuous year-round follow-up to maximize impact?',
        options: [
          { text: 'Yes', value: 3 },
          { text: 'Partial', value: 2 },
          { text: 'No', value: 1 }
        ]
      },
      {
        id: 15,
        text: 'Are learnings from past events used to improve future strategy?',
        options: [
          { text: 'Yes', value: 3 },
          { text: 'Partial', value: 2 },
          { text: 'No', value: 1 }
        ]
      }
    ]
  }
];

export const getTier = (score: number): Tier => {
  if (score >= 41) return 'Mature';
  if (score >= 31) return 'Growing';
  if (score >= 21) return 'Developing';
  return 'Early';
};

export const TIER_MESSAGES = {
  Mature: 'Mature ecosystem – Your events are fully integrated across touchpoints, delivering measurable ROI.',
  Growing: 'Growing ecosystem – Strong initiatives in place, but gaps exist in follow-up or measurement.',
  Developing: 'Developing ecosystem – Some touchpoints exist, but opportunities to connect events and maximize ROI are significant.',
  Early: 'Early stage – Most events are siloed; building a connected ecosystem is critical for measurable impact.'
};

export const SECTION_TIPS: Record<string, string> = {
  A: 'Optimize sponsorships by securing lead-gen commitments and pre-event appointment setting.',
  B: 'Deepen customer loyalty by shifting from passive webinars to collaborative user groups.',
  C: 'Leverage partner networks to split costs while doubling audience reach and authority.',
  D: 'Executive events should prioritize quality of interaction over quantity of attendees.',
  E: 'The scan shows that closing the measurement loop is your fastest path to increased budget.'
};